export const generateUrlWithIds = (path: string): string =>
  location.pathname.includes(path) ? location.pathname : ''
